<template>
    <div class="common-form-wrapper schedulers">
        <div class="wrapper">
            <span v-if="$v.value.name.$invalid" class="tooltiptext">{{
                errorDisplay($v.value.name, { val: MAX_NAME_LENGTH })
            }}</span>
            <div class="input-with-insidelabel" :class="{ tooltiperror: $v.value.name.$invalid }">
                <input
                    id="forAT_AccessGroup-Name"
                    ref="schedulerName"
                    class="time-input"
                    :value="value.name"
                    @input="update('name', $event.target.value) && $v.value.name.$touch()"
                />
                <label for="forAT_AccessGroup-Name">{{
                    $t('wanderManagement.accessGroupsTab.accessGroup.name')
                }}</label>
            </div>
        </div>
        <div class="wrapper-pattern schedulers">
            <div class="chkbox">
                <input
                    id="scheduler-enabled"
                    type="checkbox"
                    :checked="value.enabled"
                    :disabled="enableCheckIsDisabled"
                    @change="update('enabled', $event.target.checked)"
                />
                <label for="scheduler-enabled"></label>
                <label for="scheduler-enabled">{{ $t('wanderManagement.schedulersTab.enabled') }} </label>
            </div>
            <div v-if="enableCheckIsDisabled" class="schedulers-allert">
                <span class="tooltiptext">
                    {{ $t('wanderManagement.schedulersTab.notPossibleToEnableSingleLocationSchedulerInfo') }}
                </span>
                <div v-if="enableCheckIsDisabled" class="icon-allert"></div>
            </div>
        </div>
        <div class="wrapper">
            <SelectBox
                :placeholder="$t('wanderManagement.schedulersTab.door')"
                :value="value.location_id || 'null'"
                :options="doors"
                @input="update('location_id', $event)"
            />
        </div>
        <div class="wrapper">
            <SelectBox
                :placeholder="$t('wanderManagement.schedulersTab.doorStatus')"
                :value="value.door_state"
                :search="false"
                :options="doorsStatus"
                @input="update('door_state', $event)"
            />
        </div>
        <div class="wrapper-pattern">
            <div class="wrapper-text door-status">
                <span>{{ $t('wanderManagement.schedulersTab.doorStatusOutside') }}:</span>
                <p v-if="doorStateOutside" class="door-status-label">
                    <img class="door-icon" :src="doorIcon(doorStateOutside.peripheral_icon)" alt="door" />
                    <span>{{ doorStateOutside.peripheral_name }}</span>
                </p>
                <span v-if="!doorStateOutside" class="door-status-label">{{
                    $t('wanderManagement.schedulersTab.defaultDoorStatusOutside')
                }}</span>
            </div>
        </div>
        <div class="time-week-wrapper">
            <TimeWindows
                :value="value.time ? value.time : []"
                :show-labels="false"
                :class="'time-windows-inline'"
                @update="update('time', $event)"
            />
            <WeekSchedule v-model="value.time" />
        </div>
    </div>
</template>

<script type="text/babel">
import SelectBox from '../../common/SelectBox';
import mappingState from '../../common/mappingState';
import {
    minimumLength,
    maximumNameLength,
    forbidden,
    forbiddenNames,
    errorDisplay,
} from '../../../validators';
import { MAX_NAME_LENGTH, ROUTE_NAMES } from '../../../constants';
import TimeWindows from './timewindows/TimeWindows';
import WeekSchedule from './timewindows/WeekSchedule';

export default {
    components: {
        SelectBox,
        TimeWindows,
        WeekSchedule,
    },

    mixins: [mappingState],

    constants: {
        MAX_NAME_LENGTH,
    },

    props: {
        doors: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },

        forbiddenNames: {
            type: Array,
            required: false,
            default: () => [],
        },

        enableCheckIsDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            doorsStatus: [
                { value: 0, name: this.$t('wanderManagement.schedulersTab.closed') },
                { value: 1, name: this.$t('wanderManagement.schedulersTab.opened') },
            ],
        };
    },

    computed: {
        doorStateOutside() {
            return this.doors.find(door => door.value === this.value.location_id);
        },
    },

    watch: {
        value: {
            handler() {
                this.setFormValid(!this.$v.validationGroup.$invalid);
            },
            deep: true,
        },
        '$route.path'() {
            if (this.$router.currentRoute.name === ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS__ADD) {
                this.$refs.schedulerName.select();
            }
        },
    },

    mounted() {
        this.$watch('$v.validationGroup.$invalid', value => {
            this.setFormValid(!value);
        });

        if (this.$router.currentRoute.name === ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS__ADD) {
            this.$refs.schedulerName.select();
        }
    },

    validations() {
        return {
            value: {
                name: {
                    minimumLength,
                    maximumNameLength,
                    forbidden,
                    forbiddenNames: (val, rule) => {
                        rule = this.forbiddenNames;
                        return forbiddenNames(val, rule);
                    },
                },
            },
            validationGroup: ['value.name'],
        };
    },

    methods: {
        errorDisplay,

        update(field, item) {
            this.$emit('input', { ...this.value, [field]: item });
        },

        doorIcon(iconName) {
            return `static/img/devices/${iconName}_24px.png`;
        },
    },
};
</script>

<style scoped></style>
